import Base from "@/controllers/base";
export default class EModal extends Base {
  constructor(elem) {
    super(elem);
  }

  init() {
    const frame = this.elem.dataset.frame;
    const width = this.elem.dataset.width;
    setTimeout(() => NApp.resizeModal(frame, { width }), 100);
  }
}
